import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.25 7a.75.75 0 0 0 1.5 0V5.75h6.5V7a.75.75 0 0 0 1.5 0V5.75H20a.25.25 0 0 1 .25.25v4a.75.75 0 0 0 1.5 0V6A1.75 1.75 0 0 0 20 4.25h-3.25V3a.75.75 0 0 0-1.5 0v1.25h-6.5V3a.75.75 0 0 0-1.5 0v1.25H4A1.75 1.75 0 0 0 2.25 6v13c0 .966.784 1.75 1.75 1.75h6a.75.75 0 0 0 0-1.5H4a.25.25 0 0 1-.25-.25V6A.25.25 0 0 1 4 5.75h3.25zm14.357 8.441a.75.75 0 0 0-1.214-.882l-3.697 5.083-1.053-1.755a.75.75 0 1 0-1.286.772l1.248 2.079a1.25 1.25 0 0 0 2.082.092z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }